/**
 * StorageService
 * localStorage abstraction with auto-serialization
 */
export class StorageService {
    constructor(prefix = 'discovery-') {
        this.prefix = prefix;
    }

    _getKey(key) {
        return `${this.prefix}${key}`;
    }

    /**
     * Save data to localStorage
     * @param {string} key
     * @param {any} data
     */
    save(key, data) {
        try {
            const json = JSON.stringify({
                data,
                timestamp: Date.now()
            });
            localStorage.setItem(this._getKey(key), json);
            return true;
        } catch (error) {
            console.error('StorageService.save error:', error);
            return false;
        }
    }

    /**
     * Load data from localStorage
     * @param {string} key
     * @param {number} maxAge - Max age in milliseconds (default 24h)
     * @returns {any|null}
     */
    load(key, maxAge = 24 * 60 * 60 * 1000) {
        try {
            const json = localStorage.getItem(this._getKey(key));
            if (!json) return null;

            const { data, timestamp } = JSON.parse(json);
            const age = Date.now() - timestamp;

            if (age > maxAge) {
                console.log(`Storage expired: ${key} (age: ${Math.round(age/1000/60)}min)`);
                this.remove(key);
                return null;
            }

            return data;
        } catch (error) {
            console.error('StorageService.load error:', error);
            return null;
        }
    }

    /**
     * Check if key exists
     */
    has(key) {
        return localStorage.getItem(this._getKey(key)) !== null;
    }

    /**
     * Remove key
     */
    remove(key) {
        localStorage.removeItem(this._getKey(key));
    }

    /**
     * Clear all prefixed keys
     */
    clear() {
        const keys = Object.keys(localStorage);
        keys.forEach(key => {
            if (key.startsWith(this.prefix)) {
                localStorage.removeItem(key);
            }
        });
    }
}
